import React, { useEffect, useMemo, useState } from "react";
import { createPortal } from "react-dom";
import { connect } from "react-redux";
import "./style.css";
import { useHistory } from "react-router-dom";
import baseUrlNew from "../BaseUrl/index";
import axios from "axios";
import dateFormat from "dateformat";
import { ShimmerThumbnail } from "react-shimmer-effects";
import { BiRightArrowAlt, BiSearch } from "react-icons/bi";
import {
  HiOutlineInformationCircle,
  HiChevronLeft,
  HiChevronRight,
  HiViewGrid,
  HiViewList,
  HiOutlineClipboardList,
  HiOutlineCheckCircle,
  HiOutlineCollection,
  HiX,
  HiOutlineMail,
  HiOutlinePhone,
  HiOutlineLocationMarker,
  HiOutlineOfficeBuilding,
} from "react-icons/hi";
import { MdOutlineGavel, MdOutlineStorefront } from "react-icons/md";
import { getcardetaol_ } from "../Redux/reduxflow/action";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import { ToastContainer, toast } from "react-toastify";
import InspectionShell from "../components/InspectionShell";
import carFallbackIcon from "../assets/svg/car.svg";
import { enrichCarsWithInspectProgress, readCachedInspect } from "../utils/inspectionProgress";

const PAGE_SIZE_MOBILE = 4;
const PAGE_SIZE_DESKTOP = 8;

function normalizeDestination(at) {
  const raw = String(at || "")
    .toLowerCase()
    .replace(/[\s_-]+/g, "");
  if (!raw) return "other";
  if (raw.includes("auction")) return "auction";
  if (raw.includes("buy")) return "buynow";
  return raw;
}

function destinationLabel(id) {
  if (id === "auction") return "Auction";
  if (id === "buynow") return "Buy Now";
  if (id === "other") return "Other";
  return id.charAt(0).toUpperCase() + id.slice(1);
}

function getBrandName(item) {
  return (
    item.brand_name ||
    item.brand ||
    item.make ||
    item.brands_name ||
    ""
  );
}

function getBrandImage(item) {
  return (
    item.brands_image ||
    item.brand_image ||
    item.brand_logo ||
    item.logo ||
    item.brand?.brand_image ||
    item.brand?.brands_image ||
    null
  );
}

function VehicleVisual({ item }) {
  const [failed, setFailed] = useState(false);
  const image = getBrandImage(item);

  if (image && !failed) {
    return (
      <div className="pi-insp-card__visual pi-insp-card__visual--logo">
        <img src={image} alt="" onError={() => setFailed(true)} />
      </div>
    );
  }

  return (
    <div className="pi-insp-card__visual pi-insp-card__visual--car">
      <img src={carFallbackIcon} alt="" aria-hidden />
    </div>
  );
}

export const UserCarList = () => {
  const history = useHistory();
  const [usercar_list, setusercar_list] = useState([]);
  const [loding_list, setloding_list] = useState(true);
  const [proceed_option, setproceed_option] = useState(0);
  const [placing, setPlacing] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [group, setGroup] = useState("inspections"); // inspections | ready | placed
  const [placedTab, setPlacedTab] = useState("auction"); // auction | buynow | other
  const [query, setQuery] = useState("");
  const [page, setPage] = useState(1);
  const [viewMode, setViewMode] = useState(() => {
    try {
      return localStorage.getItem("INSPECTION_view_mode") === "list"
        ? "list"
        : "grid";
    } catch {
      return "grid";
    }
  });
  const [isDesktop, setIsDesktop] = useState(() =>
    typeof window !== "undefined"
      ? window.matchMedia("(min-width: 900px)").matches
      : false
  );
  const ref = React.useRef("0");
  const pageSize = isDesktop ? PAGE_SIZE_DESKTOP : PAGE_SIZE_MOBILE;

  useEffect(() => {
    User_Car_List();
  }, []);

  useEffect(() => {
    const mq = window.matchMedia("(min-width: 900px)");
    const onChange = () => setIsDesktop(mq.matches);
    onChange();
    if (mq.addEventListener) mq.addEventListener("change", onChange);
    else mq.addListener(onChange);
    return () => {
      if (mq.removeEventListener) mq.removeEventListener("change", onChange);
      else mq.removeListener(onChange);
    };
  }, []);

  useEffect(() => {
    setPage(1);
  }, [group, placedTab, query, pageSize]);

  useEffect(() => {
    if (proceed_option !== 1) return undefined;
    confirmAlert({
      title: "Confirm to submit",
      message: "Select the section to make this car available for",
      buttons: [
        {
          label: "Auction",
          onClick: () => {
            void placeInspection("auction");
          },
        },
        {
          label: "Buy Now",
          onClick: () => {
            void placeInspection("buynow");
          },
        },
      ],
    });
    setproceed_option(0);
    return undefined;
  }, [proceed_option]);

  const placeInspection = async (choice) => {
    const carId = ref.current;
    if (!carId || placing) return;
    setPlacing(true);
    try {
      await axios.post(`${baseUrlNew.baseUrl}api/v1/move_inspection/`, {
        choice,
        car_id: carId,
      });
      toast(
        choice === "auction"
          ? "The car has been added in auction. Please contact administrator to provide further details."
          : "The car has been added in buy now section. Please contact administrator to provide further details."
      );
      setGroup("placed");
      setPlacedTab(choice === "auction" ? "auction" : "buynow");
      User_Car_List();
    } catch (err) {
      toast.error("Could not place this car. Please try again.");
    } finally {
      setPlacing(false);
    }
  };

  const User_Car_List = () => {
    setloding_list(true);
    axios
      .post(`${baseUrlNew.baseUrl}api/v1/inspection_cars/`, {
        user: localStorage.getItem("INSPECTION_User_Id"),
      })
      .then((response) => {
        const raw = response.data.data || [];
        // Don't trust API inspect (questions-only). Show cached client %
        // immediately, then recompute media + questions for every car.
        const cars = raw.map((car) => {
          const carId = car.car_id || car.id;
          const cached = readCachedInspect(carId);
          return {
            ...car,
            inspect: cached != null ? cached : 0,
            inspectReady: cached != null,
          };
        });
        setusercar_list(cars);
        setloding_list(false);

        const priorityIds = cars
          .filter((car) => !car.available && !car.proceed)
          .map((car) => car.car_id || car.id);

        enrichCarsWithInspectProgress(
          cars,
          (updated) => {
            setusercar_list(updated);
          },
          { priorityIds, batchSize: 6 }
        ).catch(() => {
          /* keep cached client values */
        });
      })
      .catch(() => {
        setusercar_list([]);
        setloding_list(false);
      });
  };

  const logout = () => {
    localStorage.removeItem("INSPECTION_User_Id");
    window.location.reload(false);
  };

  const placedDestinations = useMemo(() => {
    const found = new Set();
    usercar_list.forEach((item) => {
      if (item.available) found.add(normalizeDestination(item.at));
    });
    const ordered = ["auction", "buynow"];
    found.forEach((id) => {
      if (!ordered.includes(id)) ordered.push(id);
    });
    if (!ordered.includes("auction")) ordered.unshift("auction");
    if (!ordered.includes("buynow")) ordered.splice(1, 0, "buynow");
    return ordered;
  }, [usercar_list]);

  const counts = useMemo(() => {
    const next = {
      inspections: 0,
      ready: 0,
      placed: 0,
      auction: 0,
      buynow: 0,
      other: 0,
    };
    usercar_list.forEach((item) => {
      if (!item.available && !item.proceed) next.inspections += 1;
      else if (!item.available && item.proceed) next.ready += 1;
      else if (item.available) {
        next.placed += 1;
        const dest = normalizeDestination(item.at);
        next[dest] = (next[dest] || 0) + 1;
      }
    });
    return next;
  }, [usercar_list]);

  const filteredList = useMemo(() => {
    const q = query.trim().toLowerCase();
    return usercar_list.filter((item) => {
      let inGroup = false;
      if (group === "inspections") {
        inGroup = !item.available && !item.proceed;
      } else if (group === "ready") {
        inGroup = !item.available && !!item.proceed;
      } else {
        inGroup =
          !!item.available && normalizeDestination(item.at) === placedTab;
      }
      if (!inGroup) return false;
      if (!q) return true;
      const haystack = [
        item.name,
        getBrandName(item),
        item.provider_name,
        item.city,
        item.at,
      ]
        .filter(Boolean)
        .join(" ")
        .toLowerCase();
      return haystack.includes(q);
    });
  }, [usercar_list, group, placedTab, query]);

  const totalPages = Math.max(1, Math.ceil(filteredList.length / pageSize));
  const safePage = Math.min(page, totalPages);
  const pageItems = filteredList.slice(
    (safePage - 1) * pageSize,
    safePage * pageSize
  );

  const openInspection = (item) => {
    history.push({
      pathname: "/inspection/carsteps",
      state: {
        id: item.car_id,
        car_name: item.name,
        report: item.report,
        inspect: item.inspect,
        // Full inspection_cars row — answered checklist lives on this payload.
        inspectionCar: item,
      },
    });
  };

  const askProceed = (item) => {
    if (placing) return;
    confirmAlert({
      title: "Confirm to submit",
      message: "Are you sure you want to proceed this inspection further?",
      buttons: [
        {
          label: "Yes",
          onClick: () => {
            ref.current = item.car_id;
            setproceed_option(1);
          },
        },
        { label: "No", onClick: () => setproceed_option(3) },
      ],
    });
  };

  const groupCopy = {
    inspections: {
      title: "Active inspections",
      text: "Vehicles that still need checklist work.",
    },
    ready: {
      title: "Ready to place",
      text: "Send these into Auction or Buy Now.",
    },
    placed: {
      title:
        placedTab === "auction"
          ? "Auction inventory"
          : placedTab === "buynow"
          ? "Buy Now inventory"
          : `${destinationLabel(placedTab)} inventory`,
      text: "Vehicles already moved out of inspection.",
    },
  }[group];

  const selectQueue = (nextGroup, nextPlacedTab) => {
    setGroup(nextGroup);
    if (nextPlacedTab) {
      setPlacedTab(nextPlacedTab);
    }
  };

  const changeViewMode = (mode) => {
    setViewMode(mode);
    try {
      localStorage.setItem("INSPECTION_view_mode", mode);
    } catch {
      /* ignore */
    }
  };

  const pageNumbers = useMemo(() => {
    if (totalPages <= 5) {
      return Array.from({ length: totalPages }, (_, i) => i + 1);
    }
    const set = new Set([1, totalPages, safePage, safePage - 1, safePage + 1]);
    return Array.from(set)
      .filter((n) => n >= 1 && n <= totalPages)
      .sort((a, b) => a - b);
  }, [totalPages, safePage]);

  return (
    <InspectionShell
      badge="Inspection"
      title="Vehicles"
      onLogout={logout}
      showFooter
      className="pi-inspection-page--app"
      mainClassName="pi-inspection-main--dashboard"
      bottomNav={
        <nav className="pi-insp-tabbar" aria-label="Main queues">
          <button
            type="button"
            className={`pi-insp-tabbar__item${
              group === "inspections" ? " is-active" : ""
            }`}
            onClick={() => selectQueue("inspections")}
          >
            <HiOutlineClipboardList />
            <span>Inspect</span>
            <em>{counts.inspections}</em>
          </button>
          <button
            type="button"
            className={`pi-insp-tabbar__item${
              group === "ready" ? " is-active" : ""
            }`}
            onClick={() => selectQueue("ready")}
          >
            <HiOutlineCheckCircle />
            <span>Ready</span>
            <em>{counts.ready}</em>
          </button>
          <button
            type="button"
            className={`pi-insp-tabbar__item${
              group === "placed" ? " is-active" : ""
            }`}
            onClick={() => selectQueue("placed", placedTab || "auction")}
          >
            <HiOutlineCollection />
            <span>Placed</span>
            <em>{counts.placed}</em>
          </button>
        </nav>
      }
    >
      <div className="pi-insp-studio">
        <header className="pi-insp-studio__hero">
          <div className="pi-insp-studio__hero-copy">
            <div className="pi-insp-studio__hero-title">
              <p className="pi-inspection-label">AutoTrade Port · Inspection</p>
              <h1>Inspection hub</h1>
            </div>
            <p className="pi-insp-studio__hero-desktop">
              Full workspace for active inspections, ready vehicles, and placed
              inventory.
            </p>
            <p className="pi-insp-studio__hero-mobile">
              Your inspection queue for today.
            </p>
          </div>

          <div className="pi-insp-dash" aria-label="Queue summary">
            <button
              type="button"
              className={`pi-insp-dash__card${
                group === "inspections" ? " is-active" : ""
              }`}
              onClick={() => selectQueue("inspections")}
            >
              <span className="pi-insp-dash__icon" aria-hidden>
                <HiOutlineClipboardList />
              </span>
              <span>Inspections</span>
              <strong>{counts.inspections}</strong>
            </button>
            <button
              type="button"
              className={`pi-insp-dash__card${
                group === "ready" ? " is-active" : ""
              }`}
              onClick={() => selectQueue("ready")}
            >
              <span className="pi-insp-dash__icon" aria-hidden>
                <HiOutlineCheckCircle />
              </span>
              <span>Ready</span>
              <strong>{counts.ready}</strong>
            </button>
            <button
              type="button"
              className={`pi-insp-dash__card${
                group === "placed" && placedTab === "auction" ? " is-active" : ""
              }`}
              onClick={() => selectQueue("placed", "auction")}
            >
              <span className="pi-insp-dash__icon" aria-hidden>
                <MdOutlineGavel />
              </span>
              <span>Auction</span>
              <strong>{counts.auction || 0}</strong>
            </button>
            <button
              type="button"
              className={`pi-insp-dash__card${
                group === "placed" && placedTab === "buynow" ? " is-active" : ""
              }`}
              onClick={() => selectQueue("placed", "buynow")}
            >
              <span className="pi-insp-dash__icon" aria-hidden>
                <MdOutlineStorefront />
              </span>
              <span>Buy Now</span>
              <strong>{counts.buynow || 0}</strong>
            </button>
          </div>
        </header>

        <div className="pi-insp-studio__layout">
          <aside className="pi-insp-side" aria-label="Vehicle queues">
            <p className="pi-insp-side__label">Workspace</p>

            <button
              type="button"
              className={`pi-insp-side__item${
                group === "inspections" ? " is-active" : ""
              }`}
              onClick={() => selectQueue("inspections")}
            >
              <span>
                <HiOutlineClipboardList aria-hidden /> Inspections
              </span>
              <em>{counts.inspections}</em>
            </button>

            <button
              type="button"
              className={`pi-insp-side__item${
                group === "ready" ? " is-active" : ""
              }`}
              onClick={() => selectQueue("ready")}
            >
              <span>
                <HiOutlineCheckCircle aria-hidden /> Ready
              </span>
              <em>{counts.ready}</em>
            </button>

            <p className="pi-insp-side__label pi-insp-side__label--spaced">
              Placed
            </p>

            {placedDestinations.map((id) => (
              <button
                key={id}
                type="button"
                className={`pi-insp-side__item pi-insp-side__item--sub${
                  group === "placed" && placedTab === id ? " is-active" : ""
                }`}
                onClick={() => selectQueue("placed", id)}
              >
                <span>
                  {id === "auction" ? (
                    <MdOutlineGavel aria-hidden />
                  ) : id === "buynow" ? (
                    <MdOutlineStorefront aria-hidden />
                  ) : null}{" "}
                  {destinationLabel(id)}
                </span>
                <em>{counts[id] || 0}</em>
              </button>
            ))}
          </aside>

          <div className="pi-insp-studio__panel">
            <div className="pi-insp-studio__panel-head">
              <div className="pi-insp-studio__intro">
                <div>
                  <h2>{groupCopy.title}</h2>
                  <p>{groupCopy.text}</p>
                </div>
              </div>

              <div className="pi-insp-studio__tools">
                <div
                  className="pi-insp-studio__view"
                  role="group"
                  aria-label="View style"
                >
                  <button
                    type="button"
                    className={`pi-insp-studio__view-btn${
                      viewMode === "grid" ? " is-active" : ""
                    }`}
                    aria-pressed={viewMode === "grid"}
                    onClick={() => changeViewMode("grid")}
                    title="Grid view"
                  >
                    <HiViewGrid size={18} />
                    <span>Grid</span>
                  </button>
                  <button
                    type="button"
                    className={`pi-insp-studio__view-btn${
                      viewMode === "list" ? " is-active" : ""
                    }`}
                    aria-pressed={viewMode === "list"}
                    onClick={() => changeViewMode("list")}
                    title="List view"
                  >
                    <HiViewList size={18} />
                    <span>List</span>
                  </button>
                </div>

                <label className="pi-insp-studio__search">
                  <BiSearch size={16} aria-hidden />
                  <input
                    type="search"
                    value={query}
                    onChange={(e) => setQuery(e.target.value)}
                    placeholder="Search vehicles"
                    aria-label="Search vehicles"
                  />
                </label>
              </div>
            </div>

            {group === "placed" ? (
              <div
                className="pi-insp-studio__destinations pi-insp-studio__destinations--mobile"
                role="tablist"
                aria-label="Placed destinations"
              >
                {placedDestinations.map((id) => (
                  <button
                    key={id}
                    type="button"
                    role="tab"
                    aria-selected={placedTab === id}
                    className={`pi-insp-studio__dest${
                      placedTab === id ? " is-active" : ""
                    }`}
                    onClick={() => selectQueue("placed", id)}
                  >
                    {destinationLabel(id)}
                    <em>{counts[id] || 0}</em>
                  </button>
                ))}
          </div>
            ) : null}

            {loding_list || placing ? (
              <div className="pi-insp-studio__loading">
                {placing ? (
                  <p className="pi-insp-studio__placing" role="status">
                    Placing vehicle…
                  </p>
                ) : null}
                <ShimmerThumbnail height={120} rounded />
                <ShimmerThumbnail height={120} rounded />
              </div>
            ) : filteredList.length === 0 ? (
              <div className="pi-insp-studio__empty">
                <div className="pi-insp-studio__empty-art">
                  <img src={carFallbackIcon} alt="" aria-hidden />
                </div>
                <h3>Nothing here yet</h3>
                <p>
                  {group === "placed"
                    ? `No vehicles in ${destinationLabel(
                        placedTab
                      )}. Proceed Ready cars to populate this list.`
                    : query
                    ? "No vehicles match your search in this view."
                    : "This queue is clear for now."}
                </p>
                {group === "placed" && counts.ready > 0 ? (
                  <button
                    type="button"
                    className="pi-insp-card__primary"
                    onClick={() => selectQueue("ready")}
                  >
                    Open Ready queue
                    <BiRightArrowAlt size={18} />
                  </button>
                ) : null}
              </div>
            ) : (
              <>
                <div
                  className={`pi-insp-studio__cards pi-insp-studio__cards--${viewMode}`}
                >
                  {pageItems.map((item, index) => {
                    const progress = Math.max(
                      0,
                      Math.min(100, Number(item.inspect) || 0)
                    );
                    const progressReady = Boolean(item.inspectReady);
                    const brand = getBrandName(item);
                    const placed = normalizeDestination(item.at);
                    return (
                      <article
                        className={`pi-insp-card pi-insp-card--${viewMode}`}
                        key={item.car_id || `${item.name}-${index}`}
                        onClick={() => openInspection(item)}
                        onKeyDown={(e) => {
                          if (e.key === "Enter" || e.key === " ") {
                            e.preventDefault();
                            openInspection(item);
                          }
                        }}
                        role="button"
                        tabIndex={0}
                      >
                        <VehicleVisual item={item} />

                        <div className="pi-insp-card__content">
                          <div className="pi-insp-card__topline">
                            <div className="pi-insp-card__meta">
                              {brand ? (
                                <span className="pi-insp-card__brand">
                                  {brand}
                                </span>
                              ) : null}
                              <h3>{item.name}</h3>
                              <p>
                                {item.assign_data
                                  ? dateFormat(item.assign_data, "dd mmm yyyy")
                                  : "Date unavailable"}
                              </p>
                            </div>
                            <span
                              className={`pi-insp-card__status pi-insp-card__status--${
                                item.available
                                  ? placed
                                  : item.proceed
                                  ? "ready"
                                  : "active"
                              }`}
                            >
                              {item.available
                                ? destinationLabel(placed)
                                : item.proceed
                                ? "Ready"
                                : "Active"}
                            </span>
                                </div>

                          <div
                            className={`pi-insp-card__progress${
                              progressReady ? "" : " is-loading"
                            }`}
                          >
                            <div className="pi-insp-card__progress-label">
                              <span>Report</span>
                              <strong>
                                {progressReady ? `${progress}%` : "0%"}
                              </strong>
                            </div>
                            <div className="pi-insp-card__track">
                              <span
                                style={{
                                  width: progressReady ? `${progress}%` : "0%",
                                }}
                              />
                                      </div>
                                    </div>

                          <div
                            className="pi-insp-card__actions"
                            onClick={(e) => e.stopPropagation()}
                          >
                                <button
                              type="button"
                              className="pi-insp-card__ghost"
                              onClick={() => setSelectedItem(item)}
                            >
                              <HiOutlineInformationCircle size={17} />
                              Details
                                </button>
                            {!item.available && item.proceed ? (
                                      <button
                                type="button"
                                className="pi-insp-card__gold"
                                onClick={() => askProceed(item)}
                                disabled={placing}
                                      >
                                        {placing ? "Placing…" : "Proceed"}
                                      </button>
                                ) : null}
                            <button
                              type="button"
                              className="pi-insp-card__primary"
                              onClick={() => openInspection(item)}
                            >
                              Continue
                              <BiRightArrowAlt size={18} />
                            </button>
                          </div>
                        </div>
                      </article>
                    );
                  })}
                </div>

                {totalPages > 1 ? (
                  <>
                    <nav
                      className="pi-insp-studio__pager"
                      aria-label="Pagination"
                    >
                      <button
                        type="button"
                        disabled={safePage <= 1}
                        onClick={() => setPage((p) => Math.max(1, p - 1))}
                      >
                        <HiChevronLeft size={18} />
                        Prev
                      </button>

                      <div className="pi-insp-studio__pager-pages">
                        {pageNumbers.map((n, idx) => {
                          const prev = pageNumbers[idx - 1];
                          const showGap = idx > 0 && n - prev > 1;
                          return (
                            <React.Fragment key={n}>
                              {showGap ? (
                                <span className="pi-insp-studio__pager-gap">
                                  …
                                </span>
                              ) : null}
                              <button
                                type="button"
                                className={`pi-insp-studio__pager-page${
                                  n === safePage ? " is-active" : ""
                                }`}
                                onClick={() => setPage(n)}
                              >
                                {n}
                              </button>
                            </React.Fragment>
                          );
                        })}
                      </div>

                      <button
                        type="button"
                        disabled={safePage >= totalPages}
                        onClick={() =>
                          setPage((p) => Math.min(totalPages, p + 1))
                        }
                      >
                        Next
                        <HiChevronRight size={18} />
                      </button>
                    </nav>
                    <p className="pi-insp-studio__pager-hint">
                      Showing {(safePage - 1) * pageSize + 1}–
                      {Math.min(safePage * pageSize, filteredList.length)} of{" "}
                      {filteredList.length} · {totalPages} pages
                    </p>
                  </>
                ) : null}
              </>
            )}
          </div>
        </div>
      </div>

      {selectedItem
        ? createPortal(
            <div
              className="pi-insp-sheet"
              role="dialog"
              aria-modal="true"
              aria-labelledby="pi-insp-sheet-title"
              onClick={() => setSelectedItem(null)}
            >
              <div
                className="pi-insp-sheet__panel"
                onClick={(e) => e.stopPropagation()}
              >
                <div className="pi-insp-sheet__hero">
                  <button
                    type="button"
                    className="pi-insp-sheet__close"
                    onClick={() => setSelectedItem(null)}
                    aria-label="Close details"
                  >
                    <HiX size={18} />
                  </button>

                  <div className="pi-insp-sheet__visual">
                    <VehicleVisual item={selectedItem} />
                  </div>

                  <div className="pi-insp-sheet__hero-copy">
                    {getBrandName(selectedItem) ? (
                      <span className="pi-insp-sheet__eyebrow">
                        {getBrandName(selectedItem)}
                      </span>
                    ) : (
                      <span className="pi-insp-sheet__eyebrow">
                        Vehicle details
                      </span>
                    )}
                    <h2 id="pi-insp-sheet-title">
                      {selectedItem.name || "Vehicle"}
                    </h2>
                    <div className="pi-insp-sheet__hero-meta">
                      <span
                        className={`pi-insp-card__status pi-insp-card__status--${
                          selectedItem.available
                            ? normalizeDestination(selectedItem.at)
                            : selectedItem.proceed
                            ? "ready"
                            : "active"
                        }`}
                      >
                        {selectedItem.available
                          ? destinationLabel(
                              normalizeDestination(selectedItem.at)
                            )
                          : selectedItem.proceed
                          ? "Ready"
                          : "Active"}
                      </span>
                      <span className="pi-insp-sheet__date">
                        {selectedItem.assign_data
                          ? dateFormat(selectedItem.assign_data, "dd mmm yyyy")
                          : "Date unavailable"}
                      </span>
                    </div>
                  </div>
                </div>

                <div className="pi-insp-sheet__body">
                  <section className="pi-insp-sheet__section">
                    <h3>Overview</h3>
                    <div className="pi-insp-sheet__tiles">
                      <div className="pi-insp-sheet__tile">
                        <span>Queue</span>
                        <strong>
                          {selectedItem.available
                            ? destinationLabel(
                                normalizeDestination(selectedItem.at)
                              )
                            : selectedItem.proceed
                            ? "Ready"
                            : "Inspections"}
                        </strong>
                      </div>
                      <div className="pi-insp-sheet__tile">
                        <span>Report</span>
                        <strong>
                          {selectedItem.inspectReady
                            ? `${Math.max(
                                0,
                                Math.min(100, Number(selectedItem.inspect) || 0)
                              )}%`
                            : "0%"}
                        </strong>
                      </div>
                    </div>
                    {selectedItem.note ? (
                      <p className="pi-insp-sheet__note">{selectedItem.note}</p>
                    ) : null}
                  </section>

                  <section className="pi-insp-sheet__section">
                    <h3>Contact</h3>
                    <ul className="pi-insp-sheet__list">
                      <li>
                        <HiOutlineOfficeBuilding aria-hidden />
                        <div>
                          <span>Provider</span>
                          <strong>{selectedItem.provider_name || "—"}</strong>
                        </div>
                      </li>
                      <li>
                        <HiOutlineMail aria-hidden />
                        <div>
                          <span>Email</span>
                          <strong>{selectedItem.email || "—"}</strong>
                        </div>
                      </li>
                      <li>
                        <HiOutlinePhone aria-hidden />
                        <div>
                          <span>Mobile</span>
                          <strong>{selectedItem.mobile_number || "—"}</strong>
                        </div>
                      </li>
                    </ul>
                  </section>

                  <section className="pi-insp-sheet__section">
                    <h3>Location</h3>
                    <ul className="pi-insp-sheet__list">
                      <li>
                        <HiOutlineLocationMarker aria-hidden />
                        <div>
                          <span>City</span>
                          <strong>{selectedItem.city || "—"}</strong>
                        </div>
                      </li>
                      <li>
                        <HiOutlineLocationMarker aria-hidden />
                        <div>
                          <span>Address</span>
                          <strong>{selectedItem.address || "—"}</strong>
                        </div>
                      </li>
                    </ul>
                  </section>
                </div>

                <div className="pi-insp-sheet__actions">
                  <button
                    type="button"
                    className="pi-insp-sheet__secondary"
                    onClick={() => setSelectedItem(null)}
                  >
                    Close
                  </button>
                  <button
                    type="button"
                    className="pi-insp-card__primary"
                    onClick={() => {
                      const item = selectedItem;
                      setSelectedItem(null);
                      openInspection(item);
                    }}
                  >
                    Continue inspection
                    <BiRightArrowAlt size={18} />
                  </button>
                </div>
              </div>
            </div>,
            document.querySelector(".pi-inspection-page") || document.body
          )
        : null}
      <ToastContainer />
    </InspectionShell>
  );
};

const mapStateToProps = (state) => ({
  car_detail_data: state.cardata.car_detail_data,
  loading: state.cardata.loading,
});

const mapDispatchToProps = (dispatch) => ({
    getcardetaol_: (response) => dispatch(getcardetaol_(response)),
});

export default connect(mapStateToProps, mapDispatchToProps)(UserCarList);
